// extracted by mini-css-extract-plugin
export default {"wrap":"GalleryImage_wrap__Hkn+o"};